import { Link } from "wouter";
import { FolderKanban } from "lucide-react";
import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ProjectAssignment } from "./project-assignment";

interface Props {
  kind: "quote" | "invoice";
  id: number;
  link?: { projectId: number; projectName: string };
}

export function QuickProjectAssign({ kind, id, link }: Props) {
  const [open, setOpen] = useState(false);

  if (link) {
    return (
      <Link
        href={`/projects/${link.projectId}`}
        onClick={(e) => e.stopPropagation()}
      >
        <span
          className="inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded border bg-blue-50 text-blue-700 border-blue-200 hover:bg-blue-100 transition-colors max-w-[140px] truncate"
          title={link.projectName}
        >
          <FolderKanban className="w-3 h-3 shrink-0" />
          <span className="truncate">{link.projectName}</span>
        </span>
      </Link>
    );
  }

  return (
    <>
      <Button
        size="sm"
        variant="ghost"
        className="h-6 px-2 text-xs text-muted-foreground hover:text-foreground"
        onClick={(e) => {
          e.stopPropagation();
          setOpen(true);
        }}
      >
        <FolderKanban className="w-3 h-3 mr-1" /> Assign
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent onClick={(e) => e.stopPropagation()}>
          <DialogHeader>
            <DialogTitle>Assign to project</DialogTitle>
          </DialogHeader>
          <ProjectAssignment kind={kind} id={id} />
        </DialogContent>
      </Dialog>
    </>
  );
}
